import { safeSessionStorage } from '../safeSessionStorage';

const SESSION_ID_STORAGE_KEY = 'dhUw_sessionId';

const getSessionId = (): string => {
  const idFromStorage = safeSessionStorage.getItem(SESSION_ID_STORAGE_KEY);

  if (idFromStorage) return idFromStorage;

  const userAgent = window.navigator.userAgent;
  const resolution = `${window.screen.width}x${window.screen.height}`;
  const timestamp = Date.now();
  const sessionString = `${userAgent}-${resolution}-${timestamp}`;

  const generatedId = btoa(
    Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15) +
      sessionString,
  );

  safeSessionStorage.setItem(SESSION_ID_STORAGE_KEY, generatedId);

  return generatedId;
};

export default getSessionId;
